import React from 'react';

function Loading() {
  return (
    <div className="loadingContainer">
      <div className="spinner" />
    </div>
  );
}

export default Loading;
